export default __webpack_public_path__ + "static/media/residue_practice_decompose.69ea0f97.jpg";